(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5154],{

/***/ 96874:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 20731:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(93518),
    arrayMap = __webpack_require__(29932),
    baseUnary = __webpack_require__(7518),
    cacheHas = __webpack_require__(74757);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 5976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 56560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(75703),
    defineProperty = __webpack_require__(38777),
    identity = __webpack_require__(6557);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 36128:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseDifference = __webpack_require__(20731),
    baseFlatten = __webpack_require__(21078),
    baseUniq = __webpack_require__(45652);

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

module.exports = baseXor;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 45357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(96874);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 30061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(56560),
    shortOut = __webpack_require__(21275);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 21275:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 75703:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 29246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612),
    isObjectLike = __webpack_require__(37005);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 76566:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseRest = __webpack_require__(5976),
    baseXor = __webpack_require__(36128),
    isArrayLikeObject = __webpack_require__(29246);

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

module.exports = xor;


/***/ }),

/***/ 55154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ AddCommentContainer_AddCommentContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
// EXTERNAL MODULE: ./utils/queries.ts
var queries = __webpack_require__(57917);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./helpers/postHelpers.ts
var postHelpers = __webpack_require__(68642);
// EXTERNAL MODULE: ./schema/Replies/mutations.ts
var mutations = __webpack_require__(752);
// EXTERNAL MODULE: ./schema/Post/queries.ts
var Post_queries = __webpack_require__(95313);
// EXTERNAL MODULE: ./helpers/setHelpers/index.ts
var setHelpers = __webpack_require__(95642);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
;// CONCATENATED MODULE: ./components/AddCommentContainer/AddCommentContainer.tsx



















var AddCommentContainer = function(param) {
    var communityWrapperRef = param.communityWrapperRef, parentPostId = param.parentPostId, _parentReplyId = param.parentReplyId, parentReplyId = _parentReplyId === void 0 ? null : _parentReplyId, t = param.t, renderChildren = param.renderChildren, lastCommentRef = param.lastCommentRef, onCommentSubmitted = param.onCommentSubmitted;
    var ref = (0,react.useState)(""), commentContent = ref[0], setCommentContent = ref[1];
    var ref1 = (0,react.useState)(null), commentAttachment = ref1[0], setCommentAttachment = ref1[1];
    var ref2 = (0,react.useState)(""), commentAttachmentAltText = ref2[0], setCommentAttachmentAltText = ref2[1];
    var ref3 = (0,react.useState)([]), usersMentioned = ref3[0], setUsersMentioned = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* CREATE_REPLY_MUTATION */.o4), 2), createReplyMutation = ref4[0], loading = ref4[1].loading;
    var ref5 = (0,CommunityContext/* useCommunityContext */.v1)(), currentUser = ref5.currentUser, community = ref5.community, trackEvent = ref5.trackEvent;
    var handleAttachmentChange = function(attachment) {
        setCommentAttachment(attachment);
    };
    var handleMentionsChange = function(_event, newValue, _field, mentions) {
        var mentionIds = mentions === null || mentions === void 0 ? void 0 : mentions.map(function(mention) {
            return mention === null || mention === void 0 ? void 0 : mention.id;
        });
        if (!(0,setHelpers/* areEqualSets */.s)(mentionIds, usersMentioned)) {
            setUsersMentioned(mentionIds);
        }
        setCommentContent(newValue);
    };
    var handleAttachmentAltTextChange = function(altText) {
        setCommentAttachmentAltText(altText);
    };
    var scrollToLastComment = function() {
        if (lastCommentRef && lastCommentRef.current) {
            var lastCommentNode = lastCommentRef.current;
            if (communityWrapperRef === null || communityWrapperRef === void 0 ? void 0 : communityWrapperRef.current) {
                communityWrapperRef.current.scrollTo(0, lastCommentNode.offsetTop);
            }
        }
    };
    var submitComment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var requestStatus, _obj, variables, ref, ref1, createReplyData, createReplyError, ATTACHMENT, POST_TYPE, POST_ID, POST_ID_ENCODED, HAS_MENTION, _obj1, userErrors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ;
                        variables = (_obj = {
                            discussionableId: community.id,
                            content: commentContent
                        }, (0,_define_property/* default */.Z)(_obj, parentReplyId ? "parentReplyId" : "parentPostId", parentReplyId || parentPostId), (0,_define_property/* default */.Z)(_obj, "postAttachmentInput", (0,postHelpers/* sanitizeAttachments */.O)(commentAttachment ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commentAttachment), {
                            altText: commentAttachmentAltText
                        }) : null)), (0,_define_property/* default */.Z)(_obj, "numberOfReactions", constants/* NUMBER_OF_REACTIONS */.ed), _obj);
                        if (usersMentioned === null || usersMentioned === void 0 ? void 0 : usersMentioned.length) {
                            variables.mentionedUserIds = usersMentioned;
                        }
                        if (!(commentContent || commentAttachment)) {
                            _ctx.next = 30;
                            break;
                        }
                        _ctx.prev = 5;
                        ;
                        _ctx.next = 9;
                        return createReplyMutation({
                            variables: variables,
                            refetchQueries: [
                                {
                                    query: Post_queries/* POST_QUERY */._,
                                    variables: {
                                        communityId: community.id,
                                        postId: parentPostId,
                                        numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                                    }
                                }, 
                            ],
                            update: function update(cache, param) {
                                var createReply = param.data.createReply;
                                var reply = createReply.reply;
                                var parentObject = {
                                    id: parentReplyId || parentPostId,
                                    __typename: parentReplyId ? "Reply" : "Post"
                                };
                                cache.modify({
                                    id: cache.identify(parentObject),
                                    fields: {
                                        replies: function replies() {
                                            var existingReplies = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                                            var newReplyRef = cache.writeFragment({
                                                data: reply,
                                                fragment: queries/* REPLY_FRAGMENT */.sN,
                                                fragmentName: "ReplyFields"
                                            });
                                            var newEdges = (0,_to_consumable_array/* default */.Z)(existingReplies.edges || []).concat([
                                                {
                                                    node: newReplyRef
                                                }, 
                                            ]);
                                            var newTotalCount = existingReplies.totalCount + 1;
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, existingReplies), {
                                                totalCount: newTotalCount,
                                                edges: newEdges
                                            });
                                        }
                                    }
                                });
                            }
                        });
                    case 9:
                        ref1 = _ctx.sent;
                        createReplyData = ref1.data;
                        createReplyError = ref1.errors;
                        ATTACHMENT = trackingEvents/* TrackingProperty.ATTACHMENT */.Ku.ATTACHMENT, POST_TYPE = trackingEvents/* TrackingProperty.POST_TYPE */.Ku.POST_TYPE, POST_ID = trackingEvents/* TrackingProperty.POST_ID */.Ku.POST_ID, POST_ID_ENCODED = trackingEvents/* TrackingProperty.POST_ID_ENCODED */.Ku.POST_ID_ENCODED, HAS_MENTION = trackingEvents/* TrackingProperty.HAS_MENTION */.Ku.HAS_MENTION;
                        ;
                        trackEvent(trackingEvents/* default.POST_CREATED */.ZP.POST_CREATED, (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, ATTACHMENT, commentAttachment ? commentAttachment.attachmentType : null), (0,_define_property/* default */.Z)(_obj1, POST_ID, parentReplyId ? (0,rawId/* rawId */.b)(parentReplyId) : (0,rawId/* rawId */.b)(parentPostId)), (0,_define_property/* default */.Z)(_obj1, POST_ID_ENCODED, parentReplyId || parentPostId), (0,_define_property/* default */.Z)(_obj1, POST_TYPE, parentReplyId ? constants/* EVENT_POST_TYPES.REPLY */.Aj.REPLY : constants/* EVENT_POST_TYPES.COMMENT */.Aj.COMMENT), (0,_define_property/* default */.Z)(_obj1, HAS_MENTION, !!(usersMentioned === null || usersMentioned === void 0 ? void 0 : usersMentioned.length)), _obj1));
                        onCommentSubmitted === null || onCommentSubmitted === void 0 ? void 0 : onCommentSubmitted();
                        setCommentContent("");
                        setCommentAttachment(null);
                        setCommentAttachmentAltText("");
                        scrollToLastComment();
                        setUsersMentioned([]);
                        userErrors = createReplyData === null || createReplyData === void 0 ? void 0 : (ref = createReplyData.createReply) === null || ref === void 0 ? void 0 : ref.userErrors;
                        requestStatus = constants/* SUCCESS */.MR;
                        if ((userErrors === null || userErrors === void 0 ? void 0 : userErrors.length) || (createReplyError === null || createReplyError === void 0 ? void 0 : createReplyError.length)) {
                            requestStatus = constants/* FAILURE */.an;
                            (0,toastHelpers/* genericToastAlert */.d9)();
                        }
                        _ctx.next = 30;
                        break;
                    case 26:
                        _ctx.prev = 26;
                        _ctx.t0 = _ctx["catch"](5);
                        (0,toastHelpers/* genericToastAlert */.d9)();
                        requestStatus = constants/* FAILURE */.an;
                    case 30:
                        return _ctx.abrupt("return", requestStatus);
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    26
                ]
            ]);
        }));
        return function submitComment() {
            return _ref.apply(this, arguments);
        };
    }();
    var cancelComment = function() {
        if (commentContent) {
            if (// eslint-disable-next-line no-alert
            window.confirm(t("Are you sure you want to discard your changes?"))) {
                // eslint-disable-next-line no-new
                new Promise(function(resolve) {
                    setCommentContent("");
                    setCommentAttachment(null);
                    setCommentAttachmentAltText("");
                    resolve();
                });
            }
        }
    };
    var inputProps = {
        cancelComment: cancelComment,
        color: community.primaryColor,
        value: commentContent,
        attachment: commentAttachment,
        handleInputChange: setCommentContent,
        handleMentionsChange: handleMentionsChange,
        handleAttachmentChange: handleAttachmentChange,
        handleAttachmentAltTextChange: handleAttachmentAltTextChange,
        submitComment: submitComment,
        isSubmitDisabled: loading,
        t: t
    };
    return renderChildren(inputProps, currentUser);
};
/* harmony default export */ var AddCommentContainer_AddCommentContainer = (AddCommentContainer);

;// CONCATENATED MODULE: ./components/AddCommentContainer/index.ts



/***/ }),

/***/ 95642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ areEqualSets; }
/* harmony export */ });
/* harmony import */ var lodash_xor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76566);
/* harmony import */ var lodash_xor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_xor__WEBPACK_IMPORTED_MODULE_0__);

var areEqualSets = function(listA, listB) {
    if (!listA || !listB) return false;
    return lodash_xor__WEBPACK_IMPORTED_MODULE_0___default()(listA, listB).length === 0;
};



/***/ })

}]);